/* <faq-search>
   Wraps the FAQ section. When enable_search is true on the section schema,
   a [data-q] input filters visible <details> elements by question + answer text.

   Observed children:
     [data-q]                 Search input (optional - absent when enable_search=false).
     .page-faq__item          Each <details> carries data-q (question lowercase)
                              and data-a (answer text stripped + lowercased).
     .page-faq__category      Category wrapper; auto-hidden when all its items hide.
     [data-no-results]        Empty-state paragraph.

   Dispatched events: none.
   Consumed events: none.
*/
class FaqSearch extends HTMLElement {
  constructor() {
    super();
    this._debounceTimer = null;
    this._onInput = this._onInput.bind(this);
  }

  connectedCallback() {
    this._input = this.querySelector('[data-q]');
    if (!this._input) return;
    this._items = Array.from(this.querySelectorAll('.page-faq__item'));
    this._categories = Array.from(this.querySelectorAll('.page-faq__category'));
    this._noResults = this.querySelector('[data-no-results]');
    this._input.addEventListener('input', this._onInput);
  }

  disconnectedCallback() {
    if (this._input) this._input.removeEventListener('input', this._onInput);
    if (this._debounceTimer) clearTimeout(this._debounceTimer);
  }

  _onInput(e) {
    if (this._debounceTimer) clearTimeout(this._debounceTimer);
    const q = e.target.value.trim().toLowerCase();
    this._debounceTimer = setTimeout(() => this._filter(q), 100);
  }

  _filter(q) {
    if (q === '') {
      this._items.forEach(i => i.parentElement.hidden = false);
      this._categories.forEach(c => c.hidden = false);
      if (this._noResults) this._noResults.hidden = true;
      return;
    }
    let anyVisible = false;
    this._items.forEach(item => {
      const text = (item.dataset.q || '') + ' ' + (item.dataset.a || '');
      const match = text.includes(q);
      item.parentElement.hidden = !match;
      if (match) anyVisible = true;
    });
    this._categories.forEach(cat => {
      const visibleItems = cat.querySelectorAll('.page-faq__item');
      const anyInCat = Array.from(visibleItems).some(i => !i.parentElement.hidden);
      cat.hidden = !anyInCat;
    });
    if (this._noResults) this._noResults.hidden = anyVisible;
  }
}

if (!customElements.get('faq-search')) {
  customElements.define('faq-search', FaqSearch);
}
